<template>
	<div id="Footer">
		<div class="footer-content main-btw">
			<div class="left-wrap">
				<!-- <div class="logoBox">
					<el-image style="height: 100px" fit="contain" :src="require('@/assets/image/index/logo2.png')">
					</el-image>
				</div> -->
				<div class="partner-box">
					<p class="partner-title">友情链接</p>
					<div class="partner-list flex">
						<template v-for="item in linkList">
							<a rel="nofollow" :href="item.li_url" target="_blank" class="partner-item">{{item.li_title}}</a>
						</template>
					</div>
				</div>
				<!-- <div class="partner-box">
					<p class="partner-title">配音分类</p>
					<div class="partner-list flex">
						<a rel="nofollow" href=" " target="_blank" class="partner-item">普通话</a>
						<a rel="nofollow" href=" " target="_blank" class="partner-item">普通话</a>
						<a rel="nofollow" href=" " target="_blank" class="partner-item">普通话</a>
					</div>
				</div> -->
			</div>
			<div class="right-wrap flex" style="padding-top: 20px;">
				<ul class="nav-list-box flex">
					<li class="nav-list" style="display:;">
						<h6 class="nav-title">关于</h6>
						<p><a href="javaScript:void(0)" class="nav-item nav-link" @click="goAbout(0,6)">公司介绍</a></p>
						<p><a href="javaScript:void(0)" class="nav-item nav-link" @click="goAbout(0,7)">加入我们</a></p>
						<p><a href="javaScript:void(0)" class="nav-item nav-link" @click="goAbout(2,15)">使用帮助</a></p>
						<p><a href="javaScript:void(0)" class="nav-item nav-link" @click="goAbout(2,17)">免责声明</a></p>
					</li>
					<li class="nav-list" style="display:;">
						<h6 class="nav-title">服务</h6>
						<p><a href="javaScript:void(0)" class="nav-item nav-link" @click="goAbout(1,10)">配音流程</a></p>
						<p><a href="javaScript:void(0)" class="nav-item nav-link" @click="goAbout(2,14)">常见问题</a></p>
						<p><a href="javaScript:void(0)" class="nav-item nav-link" @click="goAbout(1,12)">售后服务</a></p>
						<p><a href="javaScript:void(0)" class="nav-item nav-link" @click="goAbout(3,18)">汇款账号</a></p>
					</li>
				</ul>
				<div class="contact-wrap" style="color: #89928B;line-height: 30px;">
					<h6 class="contact-title">联系我们</h6>
					<p class="lianxi">
						客服热线：{{custObj.phone}}
					</p>
					<p class="lianxi">
						工作日：{{custObj.working}}
					</p>
					<p class="lianxi">
						公司地址：保定市朝阳北大街2238号汇博上谷大观B座1311室
					</p>
					<p class="lianxi">
						举报邮箱：{{custObj.postbox}}
					</p>

					<!-- <ul style="display: flex;margin-top: 20px;">
						<li style='padding-right: 20px;' class="lianxi">
							<svg t="1682495127406" class="icon" viewBox="0 0 1024 1024" version="1.1"
								xmlns="http://www.w3.org/2000/svg" p-id="4503" width="200" height="200">
								<path
									d="M767.818667 409.173333C867.338667 444.266667 938.666667 539.136 938.666667 650.666667c0 42.709333-10.496 83.978667-30.261334 120.842666-1.792 3.338667-4.992 8.928-9.696 16.96l14.613334 53.557334c6.506667 23.893333-15.402667 45.813333-39.296 39.296l-53.642667-14.634667-6.229333 3.669333A254.933333 254.933333 0 0 1 682.666667 906.666667c-77.994667 0-147.84-34.88-194.805334-89.888a352.608 352.608 0 0 1-56.64 4.554666c-63.338667 0-124.266667-16.853333-177.472-48.298666-1.834667-1.088-6.410667-3.733333-13.632-7.893334l-80.544 21.653334c-23.914667 6.432-45.76-15.573333-39.146666-39.434667l21.792-78.752a961.205333 961.205333 0 0 1-15.904-27.317333A336.384 336.384 0 0 1 85.333333 480c0-188.618667 154.965333-341.333333 345.888-341.333333 159.914667 0 297.984 108.010667 335.818667 259.296 0.949333 3.765333 1.173333 7.552 0.778667 11.2z m-68.106667-13.952C662.88 282.037333 555.178667 202.666667 431.221333 202.666667 275.434667 202.666667 149.333333 326.933333 149.333333 480c0 46.272 11.498667 90.837333 33.194667 130.698667 2.88 5.290667 10.176 17.706667 21.621333 36.746666a32 32 0 0 1 3.413334 25.013334l-10.517334 37.994666 39.232-10.549333a32 32 0 0 1 24.234667 3.146667c14.272 8.192 22.773333 13.098667 25.802667 14.890666A283.882667 283.882667 0 0 0 431.221333 757.333333c6.154667 0 12.288-0.192 18.389334-0.576A255.061333 255.061333 0 0 1 426.666667 650.666667c0-141.386667 114.613333-256 256-256 5.728 0 11.413333 0.192 17.045333 0.554666z m133.706667 397.056a32 32 0 0 1 3.338666-24.725333 996.672 996.672 0 0 0 15.242667-26.293333A190.997333 190.997333 0 0 0 874.666667 650.666667c0-106.037333-85.962667-192-192-192s-192 85.962667-192 192 85.962667 192 192 192a190.933333 190.933333 0 0 0 98.570666-27.2c2.208-1.322667 8.288-4.874667 18.517334-10.837334a32 32 0 0 1 24.522666-3.210666l12.565334 3.424-3.424-12.565334zM330.666667 426.666667a42.666667 42.666667 0 1 1 0-85.333334 42.666667 42.666667 0 0 1 0 85.333334z m192 0a42.666667 42.666667 0 1 1 0-85.333334 42.666667 42.666667 0 0 1 0 85.333334z m85.333333 202.666666a32 32 0 1 1 0-64 32 32 0 0 1 0 64z m149.333333 0a32 32 0 1 1 0-64 32 32 0 0 1 0 64z"
									fill="#B8B8B8" p-id="4504"></path>
							</svg>公众号
						</li>
						<li style='padding-right: 20px;' class="lianxi">
							<svg t="1682495228708" class="icon" viewBox="0 0 1024 1024" version="1.1"
								xmlns="http://www.w3.org/2000/svg" p-id="5611" width="200" height="200">
								<path
									d="M512 1024C229.6832 1024 0 794.3168 0 512S229.6832 0 512 0s512 229.6832 512 512-229.6832 512-512 512z m0-960C265.0112 64 64 265.0112 64 512S265.0112 960 512 960 960 758.9888 960 512 758.9888 64 512 64z"
									p-id="5612" fill="#B8B8B8"></path>
								<path
									d="M363.1104 828.8256c-41.5744 0-82.944-12.8-116.1216-38.912-36.7616-28.9792-58.6752-69.8368-61.7472-114.9952-3.072-46.3872 14.0288-91.3408 48.128-126.464l94.3104-97.28a32.02048 32.02048 0 0 1 45.9776 44.544l-94.3104 97.1776c-21.4016 22.016-32.0512 49.5616-30.208 77.6192 1.7408 26.8288 15.0528 51.3024 37.4784 69.0176 49.664 39.1168 126.7712 32.8704 172.032-13.7216 32.1536-33.1776 46.2848-76.0832 38.8096-117.9648l-32.8704-183.7056c-10.9568-61.2352 9.1136-123.4944 54.8864-170.7008l0.512-0.512c67.4816-69.0176 182.6816-77.6192 257.1264-18.944 36.7616 28.9792 58.7776 69.8368 61.7472 114.9952 3.072 46.3872-14.0288 91.3408-48.128 126.464l-93.3888 96.256a32.02048 32.02048 0 0 1-45.9776-44.544l93.3888-96.256c21.4016-22.016 32.0512-49.5616 30.208-77.6192-1.8432-26.8288-15.1552-51.3024-37.4784-69.0176-49.5616-39.0144-126.7712-32.8704-172.032 13.7216l-0.4096 0.4096c-31.0272 32.256-44.6464 73.9328-37.4784 114.4832l32.8704 183.7056c11.1616 62.3616-9.216 125.6448-55.9104 173.7728-37.376 38.6048-89.6 58.4704-141.4144 58.4704z"
									p-id="5613" fill="#B8B8B8"></path>
							</svg>
							小程序
						</li>
						<li style='padding-right: 20px;' class="lianxi">
							<svg t="1682495127406" class="icon" viewBox="0 0 1024 1024" version="1.1"
								xmlns="http://www.w3.org/2000/svg" p-id="4503" width="200" height="200">
								<path
									d="M767.818667 409.173333C867.338667 444.266667 938.666667 539.136 938.666667 650.666667c0 42.709333-10.496 83.978667-30.261334 120.842666-1.792 3.338667-4.992 8.928-9.696 16.96l14.613334 53.557334c6.506667 23.893333-15.402667 45.813333-39.296 39.296l-53.642667-14.634667-6.229333 3.669333A254.933333 254.933333 0 0 1 682.666667 906.666667c-77.994667 0-147.84-34.88-194.805334-89.888a352.608 352.608 0 0 1-56.64 4.554666c-63.338667 0-124.266667-16.853333-177.472-48.298666-1.834667-1.088-6.410667-3.733333-13.632-7.893334l-80.544 21.653334c-23.914667 6.432-45.76-15.573333-39.146666-39.434667l21.792-78.752a961.205333 961.205333 0 0 1-15.904-27.317333A336.384 336.384 0 0 1 85.333333 480c0-188.618667 154.965333-341.333333 345.888-341.333333 159.914667 0 297.984 108.010667 335.818667 259.296 0.949333 3.765333 1.173333 7.552 0.778667 11.2z m-68.106667-13.952C662.88 282.037333 555.178667 202.666667 431.221333 202.666667 275.434667 202.666667 149.333333 326.933333 149.333333 480c0 46.272 11.498667 90.837333 33.194667 130.698667 2.88 5.290667 10.176 17.706667 21.621333 36.746666a32 32 0 0 1 3.413334 25.013334l-10.517334 37.994666 39.232-10.549333a32 32 0 0 1 24.234667 3.146667c14.272 8.192 22.773333 13.098667 25.802667 14.890666A283.882667 283.882667 0 0 0 431.221333 757.333333c6.154667 0 12.288-0.192 18.389334-0.576A255.061333 255.061333 0 0 1 426.666667 650.666667c0-141.386667 114.613333-256 256-256 5.728 0 11.413333 0.192 17.045333 0.554666z m133.706667 397.056a32 32 0 0 1 3.338666-24.725333 996.672 996.672 0 0 0 15.242667-26.293333A190.997333 190.997333 0 0 0 874.666667 650.666667c0-106.037333-85.962667-192-192-192s-192 85.962667-192 192 85.962667 192 192 192a190.933333 190.933333 0 0 0 98.570666-27.2c2.208-1.322667 8.288-4.874667 18.517334-10.837334a32 32 0 0 1 24.522666-3.210666l12.565334 3.424-3.424-12.565334zM330.666667 426.666667a42.666667 42.666667 0 1 1 0-85.333334 42.666667 42.666667 0 0 1 0 85.333334z m192 0a42.666667 42.666667 0 1 1 0-85.333334 42.666667 42.666667 0 0 1 0 85.333334z m85.333333 202.666666a32 32 0 1 1 0-64 32 32 0 0 1 0 64z m149.333333 0a32 32 0 1 1 0-64 32 32 0 0 1 0 64z"
									fill="#B8B8B8" p-id="4504"></path>
							</svg>微信群
						</li>
					</ul> -->



					<!-- <p class="tel"><i class="iconfont iconlianxikefu"></i>
						17921017371
					</p> -->
					<!-- <div class="email-box flex">
						<p class="email-text">
							17921017371@qq.com
						</p>
						<a href="mailto:contactus@17921017371.com" target="_blank" class="btn-send btn-e4a">发送邮件</a>
					</div> -->
					<ul class="official-list main-btw" style="justify-content: left;margin-top: 0;">
						<li class="official-item">
							<svg t="1682495127406" class="icon" viewBox="0 0 1024 1024" version="1.1"
								xmlns="http://www.w3.org/2000/svg" p-id="4503" width="200" height="200">
								<path
									d="M767.818667 409.173333C867.338667 444.266667 938.666667 539.136 938.666667 650.666667c0 42.709333-10.496 83.978667-30.261334 120.842666-1.792 3.338667-4.992 8.928-9.696 16.96l14.613334 53.557334c6.506667 23.893333-15.402667 45.813333-39.296 39.296l-53.642667-14.634667-6.229333 3.669333A254.933333 254.933333 0 0 1 682.666667 906.666667c-77.994667 0-147.84-34.88-194.805334-89.888a352.608 352.608 0 0 1-56.64 4.554666c-63.338667 0-124.266667-16.853333-177.472-48.298666-1.834667-1.088-6.410667-3.733333-13.632-7.893334l-80.544 21.653334c-23.914667 6.432-45.76-15.573333-39.146666-39.434667l21.792-78.752a961.205333 961.205333 0 0 1-15.904-27.317333A336.384 336.384 0 0 1 85.333333 480c0-188.618667 154.965333-341.333333 345.888-341.333333 159.914667 0 297.984 108.010667 335.818667 259.296 0.949333 3.765333 1.173333 7.552 0.778667 11.2z m-68.106667-13.952C662.88 282.037333 555.178667 202.666667 431.221333 202.666667 275.434667 202.666667 149.333333 326.933333 149.333333 480c0 46.272 11.498667 90.837333 33.194667 130.698667 2.88 5.290667 10.176 17.706667 21.621333 36.746666a32 32 0 0 1 3.413334 25.013334l-10.517334 37.994666 39.232-10.549333a32 32 0 0 1 24.234667 3.146667c14.272 8.192 22.773333 13.098667 25.802667 14.890666A283.882667 283.882667 0 0 0 431.221333 757.333333c6.154667 0 12.288-0.192 18.389334-0.576A255.061333 255.061333 0 0 1 426.666667 650.666667c0-141.386667 114.613333-256 256-256 5.728 0 11.413333 0.192 17.045333 0.554666z m133.706667 397.056a32 32 0 0 1 3.338666-24.725333 996.672 996.672 0 0 0 15.242667-26.293333A190.997333 190.997333 0 0 0 874.666667 650.666667c0-106.037333-85.962667-192-192-192s-192 85.962667-192 192 85.962667 192 192 192a190.933333 190.933333 0 0 0 98.570666-27.2c2.208-1.322667 8.288-4.874667 18.517334-10.837334a32 32 0 0 1 24.522666-3.210666l12.565334 3.424-3.424-12.565334zM330.666667 426.666667a42.666667 42.666667 0 1 1 0-85.333334 42.666667 42.666667 0 0 1 0 85.333334z m192 0a42.666667 42.666667 0 1 1 0-85.333334 42.666667 42.666667 0 0 1 0 85.333334z m85.333333 202.666666a32 32 0 1 1 0-64 32 32 0 0 1 0 64z m149.333333 0a32 32 0 1 1 0-64 32 32 0 0 1 0 64z"
									fill="#B8B8B8" p-id="4504"></path>
							</svg>公众号
							<ul class="drop-qrcode-list flex">
								<li class="qrcode-item">
									<img :src='gzhPic' alt="" class="img-qrcode"></li>
							</ul>
						</li>
						<li class="official-item">
							<svg t="1682495228708" class="icon" viewBox="0 0 1024 1024" version="1.1"
								xmlns="http://www.w3.org/2000/svg" p-id="5611" width="200" height="200">
								<path
									d="M512 1024C229.6832 1024 0 794.3168 0 512S229.6832 0 512 0s512 229.6832 512 512-229.6832 512-512 512z m0-960C265.0112 64 64 265.0112 64 512S265.0112 960 512 960 960 758.9888 960 512 758.9888 64 512 64z"
									p-id="5612" fill="#B8B8B8"></path>
								<path
									d="M363.1104 828.8256c-41.5744 0-82.944-12.8-116.1216-38.912-36.7616-28.9792-58.6752-69.8368-61.7472-114.9952-3.072-46.3872 14.0288-91.3408 48.128-126.464l94.3104-97.28a32.02048 32.02048 0 0 1 45.9776 44.544l-94.3104 97.1776c-21.4016 22.016-32.0512 49.5616-30.208 77.6192 1.7408 26.8288 15.0528 51.3024 37.4784 69.0176 49.664 39.1168 126.7712 32.8704 172.032-13.7216 32.1536-33.1776 46.2848-76.0832 38.8096-117.9648l-32.8704-183.7056c-10.9568-61.2352 9.1136-123.4944 54.8864-170.7008l0.512-0.512c67.4816-69.0176 182.6816-77.6192 257.1264-18.944 36.7616 28.9792 58.7776 69.8368 61.7472 114.9952 3.072 46.3872-14.0288 91.3408-48.128 126.464l-93.3888 96.256a32.02048 32.02048 0 0 1-45.9776-44.544l93.3888-96.256c21.4016-22.016 32.0512-49.5616 30.208-77.6192-1.8432-26.8288-15.1552-51.3024-37.4784-69.0176-49.5616-39.0144-126.7712-32.8704-172.032 13.7216l-0.4096 0.4096c-31.0272 32.256-44.6464 73.9328-37.4784 114.4832l32.8704 183.7056c11.1616 62.3616-9.216 125.6448-55.9104 173.7728-37.376 38.6048-89.6 58.4704-141.4144 58.4704z"
									p-id="5613" fill="#B8B8B8"></path>
							</svg>
							小程序
							<ul class="drop-qrcode-list flex">
								<li class="qrcode-item">
									<img :src='xcxPic' alt="" class="img-qrcode">
								</li>
							</ul>
						</li>
						<li class="official-item">
							<svg t="1682495127406" class="icon" viewBox="0 0 1024 1024" version="1.1"
								xmlns="http://www.w3.org/2000/svg" p-id="4503" width="200" height="200">
								<path
									d="M767.818667 409.173333C867.338667 444.266667 938.666667 539.136 938.666667 650.666667c0 42.709333-10.496 83.978667-30.261334 120.842666-1.792 3.338667-4.992 8.928-9.696 16.96l14.613334 53.557334c6.506667 23.893333-15.402667 45.813333-39.296 39.296l-53.642667-14.634667-6.229333 3.669333A254.933333 254.933333 0 0 1 682.666667 906.666667c-77.994667 0-147.84-34.88-194.805334-89.888a352.608 352.608 0 0 1-56.64 4.554666c-63.338667 0-124.266667-16.853333-177.472-48.298666-1.834667-1.088-6.410667-3.733333-13.632-7.893334l-80.544 21.653334c-23.914667 6.432-45.76-15.573333-39.146666-39.434667l21.792-78.752a961.205333 961.205333 0 0 1-15.904-27.317333A336.384 336.384 0 0 1 85.333333 480c0-188.618667 154.965333-341.333333 345.888-341.333333 159.914667 0 297.984 108.010667 335.818667 259.296 0.949333 3.765333 1.173333 7.552 0.778667 11.2z m-68.106667-13.952C662.88 282.037333 555.178667 202.666667 431.221333 202.666667 275.434667 202.666667 149.333333 326.933333 149.333333 480c0 46.272 11.498667 90.837333 33.194667 130.698667 2.88 5.290667 10.176 17.706667 21.621333 36.746666a32 32 0 0 1 3.413334 25.013334l-10.517334 37.994666 39.232-10.549333a32 32 0 0 1 24.234667 3.146667c14.272 8.192 22.773333 13.098667 25.802667 14.890666A283.882667 283.882667 0 0 0 431.221333 757.333333c6.154667 0 12.288-0.192 18.389334-0.576A255.061333 255.061333 0 0 1 426.666667 650.666667c0-141.386667 114.613333-256 256-256 5.728 0 11.413333 0.192 17.045333 0.554666z m133.706667 397.056a32 32 0 0 1 3.338666-24.725333 996.672 996.672 0 0 0 15.242667-26.293333A190.997333 190.997333 0 0 0 874.666667 650.666667c0-106.037333-85.962667-192-192-192s-192 85.962667-192 192 85.962667 192 192 192a190.933333 190.933333 0 0 0 98.570666-27.2c2.208-1.322667 8.288-4.874667 18.517334-10.837334a32 32 0 0 1 24.522666-3.210666l12.565334 3.424-3.424-12.565334zM330.666667 426.666667a42.666667 42.666667 0 1 1 0-85.333334 42.666667 42.666667 0 0 1 0 85.333334z m192 0a42.666667 42.666667 0 1 1 0-85.333334 42.666667 42.666667 0 0 1 0 85.333334z m85.333333 202.666666a32 32 0 1 1 0-64 32 32 0 0 1 0 64z m149.333333 0a32 32 0 1 1 0-64 32 32 0 0 1 0 64z"
									fill="#B8B8B8" p-id="4504"></path>
							</svg>人工客服
							<ul class="drop-qrcode-list flex">
								<li class="qrcode-item">
									<img :src='wxPic' alt="" class="img-qrcode">
								</li>
							</ul>
						</li>
					</ul>
				</div>
			</div>
		</div>
		<!-- 版权所有河北保定声探网络科技有限公司 Copyright  2023 All Rights Reserved | 冀ICP备2023019598号-1 声探音频制作平台 -->
		<div class="tac-box">
			<p class="tac-top">
				<a target="_blank" rel="nofollow" href="https://beian.miit.gov.cn">冀ICP备2023019598号-1 声探音频制作平台 </a>
			</p>
			<p class="tac-bottom">
				© Copyright 2023 All Rights Reserved 河北保定声探网络科技有限公司 版权所有
			</p>
			<!-- <p class="tac-top"><a target="_blank" rel="nofollow" href="https://beian.miit.gov.cn">冀ICP备2023019598号-1 声探音频制作平台 </a>
			</p> -->
		</div>
		<Audio></Audio>
		<!-- <leftAside @goScroll='goScroll'></leftAside> -->
		<!-- <rightAside></rightAside> -->
		<!-- <leftAside></leftAside>
		<rightAside></rightAside> -->
	</div>

</template>

<script src="../assets/js/ac99ef1f9cb69e708163.js"></script>
<script src="../assets/js/1ef9ab399e4d2a7ed62d.js"></script>
<script src="../assets/js/380d3aa305f176da4c39.js"></script>
<script src="../assets/js/73b390b017176f36469d.js"></script>
<script src="../assets/js/fb7cca09538db6fcb411.js"></script>
<script>
	import Audio from "@/components/index/Audio.vue";
	import rightAside from "@/components/index/rightAside.vue";
	import leftAside from "@/components/index/leftAside.vue";
	import goTop from "@/utils/goTop.js";
	export default {
		name: "Footer",
		components: {
			Audio,
			rightAside,
			leftAside
		},
		data() {
			return {
				custObj: {
					phone: '',
					postbox: '',
					working: '',
				},
				gzhPic:'',
				xcxPic:'',
				wxPic:'',
				linkList:[]
			}
		},
		mounted() {
			this.getlinkListFn();
			this.getEmail()
			this.getConfigValue('wxq_code_img',1)
			this.getConfigValue('xxc_code_img',2)
			this.getConfigValue('gzh_code_img',3)
		},
		methods: {
			getlinkListFn(){
				var that=this;
				this.$post('/link/index', {
				}).then(res=>{
					console.log("/link/index=>",res);
					that.linkList=res.data;
				})
			},
			getConfigValue(name,num) {
				this.$post('/Index/getConfigValue', {
					name: name
				}).then(res => {
					switch (num){
						case 1:
							this.wxPic = res.data
							break;
						case 2:
							this.xcxPic = res.data
							break;
						case 3:
							this.gzhPic = res.data
							break;
						default:
							break;
					}
				})
			},
			goScroll(name) {
				this.heightList = [];
				const viewList = ['banner', 'copyright-music', 'teacher', 'authorize', 'yinyuerenBox', 'fanganBox'];
				for (var i = 0; i < viewList.length; i++) {
					this.heightList[i] = document.getElementById(viewList[i]).offsetHeight
				}
				if (name == 'teacher') {
					var top = this.heightList[0] + this.heightList[1];
				} else if (name == 'authorize') {
					var top = this.heightList[0] + this.heightList[1] + this.heightList[2];
				} else if (name == 'yinyuerenBox') {
					var top = this.heightList[0] + this.heightList[1] + this.heightList[2] + this.heightList[3];
				} else if (name == 'fanganBox') {
					var top = this.heightList[0] + this.heightList[1] + this.heightList[2] + this.heightList[3] + this
						.heightList[4];
				}
				window.scrollTo({
					top: top - 175,
					behavior: 'smooth'
				});
			},
			getEmail() {
				let data = {}
				this.$post('/Index/getcCustomer', data).then(res => {
					console.log(res)
					this.custObj = res.data
				})
			},
			goAbout(parentIndex, menuid) {
				this.$router.push({
					path: '/about',
					query: {
						parentIndex,
						menuid
					}
				})
				goTop();
			}
		},
	};
</script>

<style scoped>
	.official-item{
		margin-right: 20px;
		cursor: pointer;
	}
	.official-item:hover{
		color: #ea4335;
	}
	.partner-item:hover {
		color: #ea4335;
	}

	.nav-item:hover {
		color: #ea4335;
	}

	.lianxi {
		cursor: pointer;
	}

	.lianxi:hover {
		color: #ea4335;
	}
</style>
